import { border, flexbox, layout, opacity, space } from 'styled-system';
import styled, { css, keyframes } from '@marvelapp/styled';
const BACKGROUND_SIZE = 468;
const placeHolderShimmer = keyframes `
  0%{
    background-position: -${BACKGROUND_SIZE}px 0
  }
  100%{
    background-position: ${BACKGROUND_SIZE}px 0
  }
`;
/** @type {any} */
export const ContentLoader = styled.div `
  ${border};
  ${layout};
  ${opacity};
  ${space};
  ${flexbox};
  animation-duration: 1600ms;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${placeHolderShimmer};
  animation-timing-function: ease-in-out;

  ${(props) => props.kind === 'light' &&
    css `
      background: ${props.theme.colors.snow};
      background: linear-gradient(
        to right,
        ${props.theme.colors.snow} 8%,
        ${props.theme.colors.snowDark} 18%,
        ${props.theme.colors.snow} 33%
      );
    `};

  ${(props) => props.kind === 'medium' &&
    css `
      background: ${props.theme.colors.snowDark};
      background: linear-gradient(
        to right,
        ${props.theme.colors.snowDark} 8%,
        ${props.theme.colors.snowExtraDark} 18%,
        ${props.theme.colors.snowDark} 33%
      );
    `};

  ${(props) => props.kind === 'dark' &&
    css `
      background: ${props.theme.colors.slate};
      background: linear-gradient(
        to right,
        ${props.theme.colors.slate} 8%,
        #4a5664 18%,
        ${props.theme.colors.slate} 33%
      );
    `};

  background-size: 800px 104px;
`;
ContentLoader.defaultProps = {
    kind: 'light',
};
